import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import RestaurantList from "@/views/restaurant/RestaurantList.vue";
import store from "@/store/store";
import RoomList from "@/views/restaurant/RoomList.vue";
import BookingView from "@/views/booking/BookingView.vue";
import UsersView from "@/views/admin/UsersView.vue";
import StatsView from "@/views/StatsView.vue";
import i18n from "@/i18n";
import PageNotFound from "@/views/PageNotFound.vue";
import PublicBookingView from "@/views/public/PublicBookingView.vue";
import PrivacyPolicy from "@/views/public/PrivacyPolicy.vue";
import TermsOfService from "@/views/public/TermsOfService.vue";
import ManageBookingView from "@/views/public/ManageBookingView.vue";
import InternalError from "@/views/InternalError.vue";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    redirect: "/bookings",
    meta: {
      authentication: "Staff",
      appBar: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: {
      title: "Login",
      appBar: false
    }
  },
  {
    path: "/restaurants",
    name: "Restaurants",
    component: RestaurantList,
    meta: {
      authentication: "Manager",
      title: "Restaurants",
      appBar: true
    }
  },
  {
    path: "/rooms",
    name: "Rooms",
    component: RoomList,
    meta: {
      authentication: "Manager",
      title: "Rooms",
      appBar: true
    }
  },
  {
    path: "/stats",
    name: "Stats",
    component: StatsView,
    meta: {
      authentication: "Staff",
      title: "Stats",
      appBar: true
    }
  },
  {
    path: "/bookings",
    name: "Bookings",
    component: BookingView,
    meta: {
      authentication: "Staff",
      title: "Bookings",
      appBar: true
    }
  },
  {
    path: "/users",
    name: "Users",
    component: UsersView,
    meta: {
      authentication: "Admin",
      title: "Users",
      appBar: true
    }
  },
  {
    path: "*",
    name: "404",
    component: PageNotFound,
    meta: {
      title: i18n.tc("page.not.found.title"),
      appBar: false
    }
  },
  {
    path: "*",
    name: "500",
    component: InternalError,
    meta: {
      title: i18n.tc("internal.server.error.title"),
      appBar: false
    }
  },
  {
    path: "/public/booking/create",
    name: "Online Booking",
    component: PublicBookingView,
    meta: {
      title: "Online Booking",
      appBar: false
    }
  },
  {
    path: "/public/booking/manage",
    name: "Manage Booking",
    component: ManageBookingView,
    meta: {
      title: "Manage Booking",
      appBar: false
    }
  },
  {
    path: "/privacy",
    name: "Privacy Policy",
    component: PrivacyPolicy,
    meta: {
      title: "Privacy Policy",
      appBar: false
    }
  },
  {
    path: "/terms",
    name: "Terms Of Service",
    component: TermsOfService,
    meta: {
      title: "Terms Of Service",
      appBar: false
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { x:0, y: 0 }
  }
});

router.beforeEach(async (to, from, next) => {
  await store.dispatch("loading");
  if (to.meta?.authentication === undefined) next();
  else if (!(await store.getters.isLoggedIn())) {
    await store.dispatch("logout");
  } else if (to.meta?.authentication === "Manager" && store.getters.isManager) {
    next();
  } else if (to.meta?.authentication === "Admin" && store.getters.isAdmin)
    next();
  else if (to.meta?.authentication === "Staff" && store.getters.isStaff) next();
  else {
    next("Login");
    console.log("Not authorized, redirecting to Login");
  }
});

router.afterEach(async to => {
  document.title = to.meta?.title;
  await store.dispatch("clearLoading");
});

export default router;
